import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './PauseListingModal.css';

export default function PauseListingModal({
    open,
    onClose,
    onConfirm,
    listingName = 'this listing',
    busy = false,
}) {
    const [reason, setReason] = useState('');

    useEffect(() => {
        if (open) setReason('');
    }, [open]);

    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape' && !busy) onClose?.();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, busy, onClose]);

    if (!open) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget && !busy) onClose?.();
    };

    return createPortal(
        <div
            className="parkpro-pause-overlay"
            role="presentation"
            onClick={handleOverlayClick}
        >
            <div
                className="parkpro-pause-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="parkpro-pause-title"
            >
                <h2 id="parkpro-pause-title">Pause listing?</h2>
                <p>
                    &ldquo;{listingName}&rdquo; will be hidden from search and won&apos;t accept new bookings.
                    Existing reservations still apply. You can resume anytime.
                </p>
                <textarea
                    className="parkpro-pause-textarea"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Optional — let drivers know why (e.g. 'Closed for winter — back March 1st')"
                    rows={3}
                    maxLength={500}
                    autoFocus
                    disabled={busy}
                />
                <div className="parkpro-pause-char-count">
                    {reason.length} / 500
                </div>
                <button
                    type="button"
                    className="parkpro-pause-btn primary"
                    disabled={busy}
                    onClick={() => onConfirm(reason.trim())}
                >
                    {busy ? 'Pausing…' : 'Pause listing'}
                </button>
                <button
                    type="button"
                    className="parkpro-pause-btn text"
                    disabled={busy}
                    onClick={onClose}
                >
                    Cancel
                </button>
            </div>
        </div>,
        document.body,
    );
}
